import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, FileQuestion, DollarSign, TrendingUp, Calculator, Youtube, Users, Calendar } from 'lucide-react';
const painPoints = [{
  icon: HelpCircle,
  title: 'No sabés por dónde empezar',
  description: 'Sin saber qué mueble hacer primero ni qué materiales comprar.'
}, {
  icon: FileQuestion,
  title: 'Diseños que no salen bien',
  description: 'Sin planos reales ni medidas exactas, el resultado no se parece a lo que querías.'
}, {
  icon: DollarSign,
  title: 'Miedo a gastar mal la plata',
  description: 'Sin saber cuánto invertir ni dónde conseguir los materiales correctos en Argentina.'
}, {
  icon: TrendingUp,
  title: 'Ves muebles caros y pensás que no podés hacerlos',
  description: 'Sin un sistema claro para pasar del nivel básico al nivel que se vende caro.'
}, {
  icon: Calculator,
  title: 'No sabés cuánto cobrar',
  description: 'Sin fórmula de precio, terminás regalando tu trabajo o sin vender nada.'
}, {
  icon: Youtube,
  title: 'Tutoriales de YouTube en inglés',
  description: 'Sin método claro adaptado a materiales y proveedores argentinos.'
}, {
  icon: Users,
  title: 'No sabés cómo vender lo que fabricás',
  description: 'Tu mueble está terminado pero no tenés idea cómo conseguir el primer cliente.'
}, {
  icon: Calendar,
  title: 'Fin de mes sin ingresos',
  description: 'Sin sistema de negocio, fabricar se queda en hobby y nunca genera plata real.'
}];
export function PainPoints() {
  return <section className="py-8 md:py-16 px-4 bg-[#EDE6D8]" data-id="element-171">
      <div className="max-w-7xl mx-auto" data-id="element-172">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-5xl font-bold text-center mb-6 md:mb-12" data-id="element-173">
          ¿TE PASA ESTO?
        </motion.h2>

        <p className="text-center text-sm md:text-lg mb-6 md:mb-8 text-[#2B2724]/80" data-id="element-174">
          Si querés fabricar o vender muebles en Argentina, esto te suena
          familiar:
        </p>

        <div className="flex flex-col md:grid md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-175">
          {painPoints.map((point, index) => {
          const Icon = point.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.05
          }} whileTap={{
            scale: 0.98
          }} className="flex items-center gap-3 md:gap-4 bg-white p-3 md:p-4 rounded-lg border border-[#2B2724]/10" data-id="element-176">
                <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#C2613A]/10" data-id="element-177">
                  <Icon className="w-5 h-5 md:w-6 md:h-6 text-[#C2613A]" data-id="element-178" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-179">
                  <h3 className="font-bold text-xs md:text-sm mb-0.5" data-id="element-180">
                    {point.title}
                  </h3>
                  <p className="text-[10px] md:text-xs text-[#2B2724]/70 leading-relaxed" data-id="element-181">
                    {point.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-base md:text-2xl font-semibold italic" data-id="element-182">
          ¿Cuántos meses más vas a seguir mirando muebles de diseño que otros
          venden carísimos?
        </motion.p>
      </div>
    </section>;
}